/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Dialog as DialogBase } from '@material-ui/core';

const DialogBootStrap = withStyles((theme) => ({
  root: {
    '& .MuiDialog-container > .MuiPaper-root': {
      padding: theme.spacing(4),
      [theme.breakpoints.up('md')]: {
        minWidth: '360px',
      },
    },
    '& .MuiDialogTitle-root': {
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: theme.spacing(2),
      '& > h2': {
        fontSize: '1.2rem',
        fontWeight: 500,
      },
    },
    '& .MuiDialogContent-root': {
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: theme.spacing(2),
    },
    '& .MuiDialogActions-root ': {
      padding: 0,
      paddingTop: theme.spacing(1),
      justifyContent: 'flex-start',
    },
  },
}))(DialogBase);

export default memo((props) => <DialogBootStrap {...props} />);
